import React, { Component } from 'react';
import { formatDateTime, formatAmount } from 'src/Common/utils';


export default class CommissionTransferCard extends Component {
    render() {
        const { transfer } = this.props;
        const { amount, adjustmentAmount, adjustmentDescription} = transfer
        return (
            <div className="card shadow mb-5">
                <div className="card-header border-0">
                    <h3 className="mb-0">Valores do repasse</h3>
                </div>
                <div className="card-body">
                    <ul className="list-group list-group-flush list my--3">
                        <li className="list-group-item px-0 border-0">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">
                                        Valor do repasse
                                    </h5>
                                </div>
                                <div className="col-auto">{formatAmount(amount)}</div>
                            </div>
                        </li>
                        <li className="list-group-item px-0 border-0">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">
                                        Valor de ajuste
                                    </h5>
                                </div>
                                <div className="col-auto">{formatAmount(adjustmentAmount)}</div>
                            </div>
                        </li>
                        <li className="list-group-item px-0 border-0">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">
                                        Razão do ajuste
                                    </h5>
                                </div>
                                <div className="col-auto text-right">
                                    {adjustmentDescription ? adjustmentDescription : " SEM AJUSTE "}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Details/Details/CommissionTransferCard.js